import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PlatformService } from 'src/app/services/platform/platform.service';
import { PlatformEnum } from 'src/app/utils/platform.utils';
import { UserStorageBrowserAdapter } from './user-storage-browser.adapter';
import { UserStorageMobileAdapter } from './user-storage-mobile.adapter';
import { IUserStorageAdapter } from './user-storage.interface';

@Injectable({
  providedIn: 'root'
})
export class UserStorageAdapter {
  constructor(
    private mobileStorage: UserStorageMobileAdapter,
    private browserStorage: UserStorageBrowserAdapter,
    private platformService: PlatformService,
  ) {}

  migrateToPrefsIfNeeded(key: string): Observable<void> {
    const adapter = this.getAdapter();
    return adapter.migrateToPrefsIfNeeded(key);
  }

  get<T>(key: string): Observable<T | undefined> {
    const adapter = this.getAdapter();
    return adapter.get<T>(key);
  }

  set(key: string, value: Object): Observable<void> {
    const adapter = this.getAdapter();
    return adapter.set(key, value);
  }

  private getAdapter(): IUserStorageAdapter {
    const isBrowser = this.platformService.getPlatform() === PlatformEnum.BROWSER;
    if (isBrowser) {
      return this.browserStorage;
    } else {
      return this.mobileStorage;
    }
  }
}
